// extracted by mini-css-extract-plugin
export default {"productsCard":"ProductList_productsCard__wIiBz"};